<template>
  <div class="etms-router-body">
    <el-tabs v-model="activename" class="router-tabs-pane" @tab-click="handleClick">
      <el-tab-pane name="priceversion" label="版本管理">
        <div class="etms-router-search">
          <span class="etms-router-search-label fl">渠道：</span>
          <el-select size="mini" placeholder="请选择渠道" v-model="priceversion.search.ChannelId" class="etms-router-search-element fl" filterable>
            <el-option v-for="item in channellist" :key="item.id" :value="item.id" :label="item.channelName"></el-option>
          </el-select>
          <span class="etms-router-search-label fl">版本号：</span>
          <el-input size="mini" placeholder="请填写版本号搜索" v-model="priceversion.search.Version" class="etms-router-search-element fl"></el-input>
          <el-tooltip class="item" content="添加" placement="top">
            <el-button size="mini" type="primary" icon="el-icon-plus" class="etms-router-search-button fr" @click="insertVersion"></el-button>
          </el-tooltip>
          <el-tooltip class="item" content="搜索" placement="top">
            <el-button size="mini" type="primary" icon="el-icon-search" class="etms-router-search-button fr" @click="searchVersionClick(priceversion.priceversionlist,undefined)"></el-button>
          </el-tooltip>
          <div class="clear"></div>
        </div>
        <el-table :data="priceversion.priceversionlist" :border="true" class="etms-router-list">
          <el-table-column type="index" label="序号" align="center"></el-table-column>
          <el-table-column label="渠道" :formatter="formatterChannelName"></el-table-column>
          <el-table-column label="版本号" prop="version"></el-table-column>
          <el-table-column label="生效时间段" :formatter="formatterEffectTime"></el-table-column>
          <el-table-column label="公布状态" width="150px" align="center">
            <template slot-scope="scope">{{scope.row.openState?'公开':'私有'}}</template>
          </el-table-column>
          <el-table-column label="操作" width="150px" align="center">
            <template slot-scope="scope">
              <el-tooltip class="item" content="修改" placement="top">
                <el-button size="mini" type="primary" icon="el-icon-edit-outline" circle @click="updateVersionClick(scope.row)"></el-button>
              </el-tooltip>
              <el-tooltip class="item" content="删除" placement="top">
                <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteVersionClick(scope.row)"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog :title="priceversion.dialogtitle" :visible.sync="priceversion.dialogvisible" :modal-append-to-body="false" center width="550px">
          <el-form :ref="priceversion.form.formname" :model="priceversion.form" :rules="priceversion.form.rules" label-width="100px" class="etms-dialog-form">
            <el-form-item label="渠道：" prop="ChannelId">
              <el-select size="mini" placeholder="请选择渠道" v-model="priceversion.form.ChannelId" class="el-width-200" filterable>
                <el-option v-for="item in channellist" :key="item.id" :value="item.id" :label="item.channelName"></el-option>
              </el-select>
            </el-form-item>
            <div class="clear"></div>
            <el-form-item label="版本名称：" prop="Version">
              <el-input size="mini" placeholder="请输入版本名称" v-model="priceversion.form.Version" class="el-width-200"></el-input>
            </el-form-item>
            <div class="clear"></div>
            <el-form-item label="生效时间：" prop="TakeEffectTime">
              <el-date-picker size="mini" v-model="priceversion.form.TakeEffectTime" type="datetimerange" align="right" unlink-panels range-separator="至" start-placeholder="生效时间" end-placeholder="结束时间" :picker-options="constant.effectTimeOptions" class="el-width-250">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="公布状态：">
              <el-checkbox v-model="priceversion.form.OpenState">公布(允许他人查看此版本下价格)</el-checkbox>
            </el-form-item>
            <div class="clear"></div>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="mini" type="primary" @click="SaveVersionClick">确 定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane name="pricemanage" label="价格管理">
        <div class="etms-router-search">
          <span class="etms-router-search-label fl">渠道：</span>
          <el-select size="mini" placeholder="请选择渠道" v-model="price.search.ChannelId" class="etms-router-search-element fl" filterable>
            <el-option v-for="item in channellist" :key="item.id" :value="item.id" :label="item.channelName"></el-option>
          </el-select>
          <span class="etms-router-search-label fl">价格版本：</span>
          <el-select size="mini" placeholder="请选择价格版本" v-model="price.search.Version" class="etms-router-search-element fl" filterable>
            <el-option v-for="item in price.search.versionlist" :key="item.id" :value="item.id" :label="item.version"></el-option>
          </el-select>
          <span class="etms-router-search-label fl">物品类型：</span>
          <el-select size="mini" placeholder="请选择包裹分类" v-model="price.search.ItemType" class="etms-router-search-element fl" filterable>
            <el-option v-for="item in price.search.itemtypelist" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
          <span class="etms-router-search-label fl">线路：</span>
          <el-select size="mini" placeholder="请选择线路" v-model="price.search.ChannelLineId" class="etms-router-search-element fl" filterable>
            <el-option v-for="item in price.search.channellinelist" :key="item.id" :value="item.id" :label="item.lineName"></el-option>
          </el-select>
          <el-dropdown @command="handleCommand" class="etms-router-search-button fr">
            <el-button size="mini" type="primary">
              操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="insertprice">添加价格</el-dropdown-item>
              <el-dropdown-item command="importprice">导入价格</el-dropdown-item>
              <!-- <el-dropdown-item command="exportprice">导出价格</el-dropdown-item>
              <el-dropdown-item command="copyprice">复制价格</el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>
          <div class="clear"></div>
        </div>
        <table cellspacing="0" cellpadding="0" border="1" class="line-price-table">
          <tr>
            <th>起始值(不包含)</th>
            <th style="width:11%;">结束值(包含)</th>
            <th style="width:11%;">计费类型</th>
            <th style="width:11%;">起始价</th>
            <th style="width:11%;">百分比</th>
            <th style="width:11%;">值单位</th>
            <th style="width:11%;">单价</th>
            <th style="width:11%;">计算模式</th>
            <th style="width:11%;">操作</th>
          </tr>
          <template v-for="item in price.channelpricelist">
            <tr :key="item.feeType" style="background-color:#DFE1E7;">
              <td colspan="9" style="color:#FF7F00;">{{item.feeTypeName}}</td>
            </tr>
            <tr v-for="price in item.priceList" :key="price.id">
              <td>{{price.startValue}}</td>
              <td>{{price.endValue}}</td>
              <td>{{ constant.priceBillingTypes.filter(p=>p.value === price.priceBillingType)[0].label }}</td>
              <td>{{price.startPrice}}</td>
              <td>{{price.percent}}</td>
              <td>{{price.valueUnit}}</td>
              <td>{{price.unitPrice}}</td>
              <td>{{price.calcuModel?'手动':'自动'}}</td>
              <td>
                <el-tooltip class="item" effect="dark" content="修改" placement="top">
                  <el-button size="mini" type="primary" @click="handleEdit(price)" icon="el-icon-edit-outline" circle></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="top">
                  <el-button size="mini" type="danger" @click="handleDelete(price)" icon="el-icon-delete" circle></el-button>
                </el-tooltip>
              </td>
            </tr>
          </template>
          <tr style="background-color:#DFE1E7;">
            <td colspan="9" style="color:#FF7F00;">线路目的地</td>
          </tr>
          <tr>
            <td colspan="9">
              <span v-for="(item,index) in price.search.channellinepurposelist" :key="index" class="span-padding">{{item}}</span>
            </td>
          </tr>
        </table>
        <el-dialog :title="price.dialogInsert.dialogtitle" :visible.sync="price.dialogInsert.dialogvisible" :modal-append-to-body="false" center>
          <div class="el-form-half">
            <el-form :model="price.dialogInsert.form" :ref="price.dialogInsert.form.formname" label-width="130px" :rules="price.dialogInsert.form.rules" class="etms-dialog-form">
              <el-form-item label="费用类型：" prop="FeeType">
                <el-select size="mini" placeholder="请选择费用类型" v-model="price.dialogInsert.form.FeeType" class="el-width-200">
                  <el-option v-for="item in price.dialogInsert.feetypelist" :key="item.id" :value="item.id" :label="item.feeTypeName">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="计费类型：" prop="PriceBillingType">
                <el-select size="mini" placeholder="请选择计费类型" v-model="price.dialogInsert.form.PriceBillingType" class="el-width-200" filterable>
                  <el-option v-for="item in constant.priceBillingTypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="起始值(不包含)：" prop="StartValue">
                <el-input size="mini" type="number" placeholder="请输入起始值" v-model="price.dialogInsert.form.StartValue" class="el-width-200"></el-input>
              </el-form-item>
              <el-form-item label="结束值(包含)：" prop="EndValue">
                <el-input size="mini" type="number" placeholder="请输入结束值" v-model="price.dialogInsert.form.EndValue" class="el-width-200"></el-input>
              </el-form-item>
              <el-form-item label="起步价：" prop="StartPrice" v-show="[1,2].indexOf(price.dialogInsert.form.PriceBillingType)>-1">
                <el-input size="mini" type="number" placeholder="请输入起步价" v-model="price.dialogInsert.form.StartPrice" class="el-width-200"></el-input>
              </el-form-item>
              <el-form-item label="百分比：" prop="Percent" v-show="price.dialogInsert.form.PriceBillingType === 5">
                <el-input size="mini" type="number" placeholder="请输入百分比" v-model="price.dialogInsert.form.Percent" class="el-width-200"></el-input>
              </el-form-item>
              <el-form-item label="目标类型：" prop="TargetFeeType" v-show="price.dialogInsert.form.PriceBillingType === 5">
                <el-select size="mini" placeholder="请选择费用类型" v-model="price.dialogInsert.form.TargetFeeType" class="el-width-200">
                  <el-option v-for="item in price.dialogInsert.feetypelist" :key="item.id" :value="item.id" :label="item.feeTypeName">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="值单位：" prop="ValueUnit" v-show="[2,3,4].indexOf(price.dialogInsert.form.PriceBillingType)>-1">
                <el-input size="mini" type="number" placeholder="请输入值单位" v-model="price.dialogInsert.form.ValueUnit" class="el-width-200"></el-input>
              </el-form-item>
              <el-form-item label="单价：" prop="UnitPrice" v-show="[2,3,4].indexOf(price.dialogInsert.form.PriceBillingType)>-1">
                <el-input size="mini" type="number" placeholder="请输入单价" v-model="price.dialogInsert.form.UnitPrice" class="el-width-200"></el-input>
              </el-form-item>
              <el-form-item label="计费模式：">
                <el-checkbox v-model="price.dialogInsert.form.CalcuModel">手动(默认自动)</el-checkbox>
              </el-form-item>
              <div class="clear"></div>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button size="mini" type="primary" @click="saveChannelPrice">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog :title="price.dialogImport.dialogtitle" :visible.sync="price.dialogImport.dialogvisible" :modal-append-to-body="false" center width="400px">
          <el-form :model="price.dialogImport.form" :rules="price.dialogImport.form.rules" :ref="price.dialogImport.form.formname" label-width="100px" class="etms-dialog-form">
            <el-form-item label="文件">
              <el-upload class="upload-demo" ref="upload" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" :action="constant.openPaths.importChannelPrice" :file-list="price.dialogImport.fileList" :limit="1" :http-request="importChannelPrice" :before-remove="beforeRemove" :on-exceed="handleExceed" :auto-upload="false" list-type="text">
                <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
                <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过2mb</div>
              </el-upload>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="mini" type="success" @click="dialogImportPriceSave">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog :title="price.dialogCopying.dialogtitle" :visible.sync="price.dialogCopying.dialogvisible" :modal-append-to-body="false" center width="400px">
          <el-form :model="price.dialogCopying.form" :rules="price.dialogCopying.form.rules" :ref="price.dialogCopying.form.formname" label-width="100px" class="etms-dialog-form">
            <el-form-item label="目标渠道：" prop="TargetChannel">
              <el-select size="mini" placeholder="请选择渠道" v-model="price.dialogCopying.form.TargetChannelId" class="el-width-200" filterable>
                <el-option v-for="item in channellist" :key="item.value" v-model="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="目标版本：" prop="TargetPriceVersion">
              <el-select size="mini" placeholder="请选择价格版本" v-model="price.dialogCopying.form.TargetPriceVersionId" class="etms-router-search-element fl" filterable></el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="mini" type="primary" @click="dialogCopyPriceSave">确 定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>

export default {
  data () {
    var startValueValidate = (rule, value, callback) => {
      if (this.price.dialogInsert.form.EndValue !== '') {
        if (value >= this.price.dialogInsert.form.EndValue) {
          callback('区间异常')
        }
      }
      callback()
    }

    var endValueValidate = (rule, value, callback) => {
      if (this.price.dialogInsert.form.StartValue !== '') {
        if (value <= this.price.dialogInsert.form.StartValue) {
          callback('区间异常')
        }
      }
      callback()
    }

    var startPriceValidate = (rule, value, callback) => {
      if ([1, 2].indexOf(this.price.dialogInsert.form.PriceBillingType) > -1) {
        if (value === '') {
          callback('请填写起步价')
        }
      }
      callback()
    }

    var percentValidate = (rule, value, callback) => {
      if (this.price.dialogInsert.form.PriceBillingType === 5) {
        if (value === '') {
          callback('请填写百分比')
        }
      }
      callback()
    }

    var targetFeeTypeValidate = (rule, value, callback) => {
      if (this.price.dialogInsert.form.PriceBillingType === 5) {
        if (value === '') {
          callback('请选择目标类型')
        }
      }
      callback()
    }

    var valueUnitValidate = (rule, value, callback) => {
      if ([2, 3, 4].indexOf(this.price.dialogInsert.form.PriceBillingType) > -1) {
        if (value === '') {
          callback('请填写值单位')
        }
      }
      callback()
    }

    var unitPriceValidate = (rule, value, callback) => {
      if ([2, 3, 4].indexOf(this.price.dialogInsert.form.PriceBillingType) > -1) {
        if (value === '') {
          callback('请填写单价')
        }
      }
      callback()
    }

    return {
      activename: 'priceversion',
      userinfo: this.$cookies.get('userinfo'),
      channellist: [],
      feetypelist: [],
      priceversion: {
        search: {
          ChannelId: '',
          Version: ''
        },
        priceversionlist: [],
        dialogtitle: '添加版本',
        dialogvisible: false,
        form: {
          formname: 'versionform',
          Id: '',
          OptimisticLock: '',
          ChannelId: '',
          Version: '',
          TakeEffectTime: [],
          OpenState: false,
          rules: {
            ChannelId: [
              { required: true, message: '请选择渠道', trigger: 'change' }
            ],
            Version: [
              { required: true, message: '请填写版本号', trigger: 'blur' }
            ],
            TakeEffectTime: [
              { required: true, message: '请选择生效时间段', trigger: 'blur' }
            ]
          }
        }
      },
      price: {
        search: {
          ChannelId: '',
          Version: '',
          ItemType: '',
          ChannelLineId: '',
          itemtypelist: [],
          versionlist: [],
          channellinelist: [],
          channellinepurposelist: []
        },
        channelpricelist: [],
        dialogInsert: {
          feetypelist: [],
          dialogtitle: '添加价格',
          dialogvisible: false,
          form: {
            formname: 'insertprice',
            Id: '',
            OptimisticLock: '',
            FeeType: '',
            PriceBillingType: '',
            StartValue: '',
            EndValue: '',
            StartPrice: '',
            Percent: '',
            TargetFeeType: '',
            ValueUnit: '',
            UnitPrice: '',
            CalcuModel: false,
            rules: {
              FeeType: [
                { required: true, message: '请选择费用类型', trigger: 'change' }
              ],
              PriceBillingType: [
                { required: true, message: '请选择计费类型', trigger: 'change' }
              ],
              StartValue: [
                { required: true, message: '请填写起始值', trigger: 'blur' },
                { validator: startValueValidate, trigger: 'blur' }
              ],
              EndValue: [
                { required: true, message: '请填写结束值', trigger: 'blur' },
                { validator: endValueValidate, trigger: 'blur' }
              ],
              StartPrice: [
                { validator: startPriceValidate, trigger: 'blur' }
              ],
              Percent: [
                { validator: percentValidate, trigger: 'blur' }
              ],
              TargetFeeType: [
                { validator: targetFeeTypeValidate, trigger: 'blur' }
              ],
              ValueUnit: [
                { validator: valueUnitValidate, trigger: 'blur' }
              ],
              UnitPrice: [
                { validator: unitPriceValidate, trigger: 'blur' }
              ]
            }
          }
        },
        dialogImport: {
          dialogtitle: '导入价格',
          dialogvisible: false,
          fileList: [],
          form: {
            formname: 'importprice'
          }
        },
        dialogCopying: {
          dialogtitle: '复制价格',
          dialogvisible: false,
          form: {
            formname: 'copyingprice'
          }
        }
      },
    }
  },
  mounted () {
    this.initFeeTypes()
    this.initChannel()
    switch (this.activename) {
      case 'priceversion':
        this.searchVersionClick()
        break
    }
  },
  computed: {
    newPriceChannel () {
      return this.price.search.ChannelId
    },
    newChannelLine () {
      return this.price.search.ChannelLineId
    },
    newChannelVersion () {
      return this.price.search.Version
    },
    newItemType () {
      return this.price.search.ItemType
    }
  },
  watch: {
    newPriceChannel () {
      this.searchItemType()
      this.searchChannelLine()
      this.searchPriceVersion()
      this.searchChannelFeeTypes()
    },
    newChannelLine (val) {
      this.searchChannelLinePurpose()
      this.searchChannelPrice()
    },
    newChannelVersion (val) {
      this.searchChannelPrice()
    },
    newItemType (val) {
      this.searchChannelPrice()
    }
  },
  methods: {
    initChannel () {
      if (this.userinfo !== undefined && this.userinfo !== null) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.getChannelList, data).then(res => {
          switch (res.data.code) {
            case 200:
              self.channellist = res.data.result
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              self.$message.error(res.data.msg)
              break;
          }
        })
      }
      else {
        this.$router.push({ name: 'login' })
      }
    },
    initFeeTypes () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.getFeeTypeList, data).then(res => {
          switch (res.data.code) {
            case 200:
              self.feetypelist = res.data.result
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              self.$message.error(res.data.msg)
              break;
          }
        }).catch(error => {
          self.$message.error(error)
        })
      }
    },
    clearForm (form) {
      Object.keys(form).forEach(item => {
        if (item !== 'formname') {
          switch (typeof (form[item])) {
            case 'string':
              form[item] = ''
              break
            case 'number':
              form[item] = ''
              break
            case 'object':
              if (Array.isArray(form[item])) {
                form[item] = []
              } else { }
              break
          }
        }
      })
    },
    handleClick (tab, event) {
      switch (tab.name) {
        case 'priceversion':
          this.searchVersionClick()
          break
        case 'pricemanage':
          this.price.search.ChannelId = ''
          if (this.channellist.length > 0) {
            var channel = this.channellist[0]
            this.price.search.ChannelId = channel.id
            this.searchChannelPrice()
          }
          break
      }
    },
    searchVersionClick () {
      if (this.userinfo !== undefined && this.userinfo !== null) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          ChannelId: this.priceversion.search.ChannelId,
          Version: this.priceversion.search.Version
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.searchChannelPriceVersion, data).then(res => {
          switch (res.data.code) {
            case 200:
              self.priceversion.priceversionlist = res.data.result
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              self.$message.error(res.data.msg)
              break;
          }
        })
      }
      else {
        this.$router.push({ name: 'login' })
      }
    },
    insertVersion () {
      this.priceversion.dialogvisible = true
      this.priceversion.dialogtitle = '添加版本'
    },
    updateVersionClick (row) {
      this.priceversion.dialogtitle = '修改版本'
      this.priceversion.dialogvisible = true
      this.priceversion.form.Id = row.id
      this.priceversion.form.OptimisticLock = row.optimisticLock
      this.priceversion.form.ChannelId = row.channelId
      this.priceversion.form.Version = row.version
      this.priceversion.form.TakeEffectTime = [row.startTakeEffectTime, row.endTakeEffectTime]
      this.priceversion.form.OpenState = row.openState
    },
    deleteVersionClick (row) {
      if (this.userinfo !== undefined && this.userinfo !== null) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          Id: row.id,
          OptimisticLock: row.optimisticLock,
        }
        var self = this
        this.$confirm('此操作将永久删除该版本及该版本下的价格,是否继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          self.$ajax.post(self.constant.openPaths.deleteChannelPriceVersion, data).then(res => {
            switch (res.data.code) {
              case 200:
                self.$message({ message: res.data.msg, type: 'success' })
                self.searchVersionClick()
                break;
              case 402:
                self.$router.push({ name: 'login' })
                break
              default:
                self.$message.error(res.data.msg)
                break;
            }
          }).catch(error => { self.$message.error(error) })
        })
      }
      else {
        this.$router.push({ name: 'login' })
      }
    },
    SaveVersionClick () {
      var data = {
        UserId: this.userinfo.id,
        EnterpriseId: this.userinfo.enterpriseId,
        LoginToken: this.userinfo.loginToken,
        Id: this.priceversion.form.Id,
        OptimisticLock: this.priceversion.form.OptimisticLock,
        ChannelId: this.priceversion.form.ChannelId,
        Version: this.priceversion.form.Version,
        StartTakeEffectTime: new Date(this.priceversion.form.TakeEffectTime[0]).toLocaleString(),
        EndTakeEffectTime: new Date(this.priceversion.form.TakeEffectTime[1]).toLocaleString(),
        OpenState: this.priceversion.form.OpenState
      }
      var url = ''
      if (data.Id === '' && data.OptimisticLock === '') {
        url = this.constant.openPaths.insertChannelPriceVersion
      } else {
        url = this.constant.openPaths.updateChannelPriceVersion
      }
      if (this.userinfo !== undefined && this.userinfo !== null) {
        var self = this
        this.$refs[this.priceversion.form.formname].validate((valid) => {
          if (valid) {
            self.$ajax.post(url, data).then(res => {
              switch (res.data.code) {
                case 200:
                  self.$message({ message: res.data.msg, type: 'success' })
                  self.clearForm(self.priceversion.form)
                  self.searchVersionClick()
                  self.priceversion.dialogvisible = false
                  break;
                case 402:
                  self.$router.push({ name: 'login' })
                  break
                default:
                  self.$message.error(res.data.msg)
                  break;
              }
            }).catch(error => {
              self.$message.error(error)
            })
          }
        })
      }
      else {
        this.$router.push({ name: 'login' })
      }
    },
    formatterChannelName (row, column) {
      var channel = this.channellist.filter(item => item.id === row.channelId)[0]
      if (channel !== undefined && channel !== null) {
        return channel.channelName
      }
      return ''
    },
    formatterEffectTime (row, column) {
      return new Date(row.startTakeEffectTime).toLocaleString() + ' 至 ' + new Date(row.endTakeEffectTime).toLocaleString()
    },
    searchPriceVersion () {
      if (this.userinfo !== undefined && this.userinfo !== null) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          ChannelId: this.price.search.ChannelId
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.searchChannelPriceVersion, data).then(res => {
          switch (res.data.code) {
            case 200:
              self.price.search.versionlist = res.data.result
              if (res.data.result.length > 0) {
                self.price.search.Version = res.data.result[0].id
              } else {
                self.price.search.Version = ''
              }
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              self.$message.error(res.data.msg)
              break;
          }
        }).catch(error => {
          self.$message.error(error)
          self.price.search.versionlist = []
          self.price.search.Version = ''
        })
      }
      else {
        this.$router.push({ name: 'login' })
      }
    },
    searchChannelLine () {
      if (this.userinfo !== undefined && this.userinfo !== null) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          ChannelId: this.price.search.ChannelId
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.searchChannelLine, data).then(res => {
          switch (res.data.code) {
            case 200:
              self.price.search.channellinelist = res.data.result
              if (res.data.result.length > 0) {
                self.price.search.ChannelLineId = res.data.result[0].id
              } else {
                self.price.search.ChannelLineId = ''
              }
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              self.$message.error(res.data.msg)
              break;
          }
        }).catch(error => {
          self.$message.error(error)
          self.price.search.channellinelist = []
          self.price.search.ChannelLineId = ''
        })
      }
      else {
        this.$router.push({ name: 'login' })
      }
    },
    searchItemType () {
      var itemtypes = []
      var channel = this.channellist.filter(item => item.id === this.price.search.ChannelId)[0]
      if (channel !== null && channel !== undefined && channel.itemTypes !== null && channel.itemTypes !== undefined) {
        this.price.search.itemtypelist = this.constant.itemtypes.filter(item => channel.itemTypes.some(t => t === item.value))
        if (this.price.search.itemtypelist.length > 0) {
          this.price.search.ItemType = this.price.search.itemtypelist[0].value
        }
      }
    },
    searchChannelLinePurpose () {
      if (this.userinfo !== undefined && this.userinfo !== null) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          ChannelId: this.price.search.ChannelId,
          ChannelLineId: this.price.search.ChannelLineId
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.searchChannelLinePurpose, data).then(res => {
          switch (res.data.code) {
            case 200:
              self.price.search.channellinepurposelist = res.data.result

              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              self.$message.error(res.data.msg)
              break;
          }
        }).catch(error => {
          self.$message.error(error)
        })
      }
      else {
        this.$router.push({ name: 'login' })
      }
    },
    searchChannelPrice () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        if (this.price.search.ChannelId !== '' && this.price.search.Version !== '' && this.price.search.ItemType !== '' && this.price.search.ChannelLineId !== '') {
          var data = {
            UserId: this.userinfo.id,
            EnterpriseId: this.userinfo.enterpriseId,
            LoginToken: this.userinfo.loginToken,
            ChannelId: this.price.search.ChannelId,
            PriceVersionId: this.price.search.Version,
            ChannelLineId: this.price.search.ChannelLineId,
            ItemType: this.price.search.ItemType
          }
          var self = this
          this.$ajax.post(this.constant.openPaths.searchChannelPrice, data).then(res => {
            switch (res.data.code) {
              case 200:
                self.price.channelpricelist = res.data.result
                break;
              case 402:
                self.$router.push({ name: 'login' })
                break
              default:
                self.$message.error(res.data.msg)
                break;
            }
          }).catch(error => {
            self.$message.error(error)
          })
        } else {
          this.price.channelpricelist = []
        }
      } else {
        this.$router.push({ name: 'login' })
      }

    },
    searchChannelFeeTypes () {
      var channel = this.channellist.filter(item => item.id === this.price.search.ChannelId)[0]
      if (channel !== null) {
        this.price.dialogInsert.feetypelist = this.feetypelist.filter(item => channel.feeTypes.some(f => item.id === f))
      }
    },
    handleCommand (command) {
      switch (command) {
        case 'insertprice':
          this.price.dialogInsert.dialogtitle = '添加价格'
          this.price.dialogInsert.dialogvisible = true
          break
        case 'importprice':
          this.price.dialogImport.dialogtitle = '导入价格'
          this.price.dialogImport.dialogvisible = true
          break
        case 'exportprice':
          break
        case 'copyprice':
          this.price.dialogCopying.dialogtitle = '复制价格'
          this.price.dialogCopying.dialogvisible = true
          break
        default:
          break
      }
      // this.$message('click on item ' + command);
    },
    handleEdit (row) {
      this.price.dialogInsert.dialogvisible = true
      this.price.dialogInsert.dialogtitle = '修改价格'
      this.price.dialogInsert.form.Id = row.id
      this.price.dialogInsert.form.OptimisticLock = row.optimisticLock
      this.price.dialogInsert.form.FeeType = row.feeType
      this.price.dialogInsert.form.PriceBillingType = row.priceBillingType
      this.price.dialogInsert.form.StartValue = row.startValue
      this.price.dialogInsert.form.EndValue = row.endValue
      this.price.dialogInsert.form.StartPrice = row.startPrice
      this.price.dialogInsert.form.Percent = row.percent
      this.price.dialogInsert.form.TargetFeeType = row.targetFeeType
      this.price.dialogInsert.form.ValueUnit = row.valueUnit
      this.price.dialogInsert.form.UnitPrice = row.unitPrice
      this.price.dialogInsert.form.CalcuModel = row.calcuModel
    },
    handleDelete (row) {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          Id: row.id,
          OptimisticLock: row.optimisticLock
        }
        var self = this
        this.$confirm('此操作将永久删除该区间段价格,是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          self.$ajax.post(self.constant.openPaths.deleteChannelPrice, data).then(res => {
            switch (res.data.code) {
              case 200:
                self.$message({ message: res.data.msg, type: 'success' })
                self.searchChannelPrice()
                break;
              case 402:
                self.$router.push({ name: 'login' })
                break
              default:
                self.$message.error(res.data.msg)
                break;
            }
          }).catch(error => { self.$message.error(error) })
        })
      } else {
        this.$router.push({ name: 'login' })
      }
    },
    saveChannelPrice () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          Id: this.price.dialogInsert.form.Id,
          OptimisticLock: this.price.dialogInsert.form.OptimisticLock,
          ChannelId: this.price.search.ChannelId,
          PriceVersion: this.price.search.Version,
          ChannelLineId: this.price.search.ChannelLineId,
          ItemType: this.price.search.ItemType,
          FeeType: this.price.dialogInsert.form.FeeType,
          PriceBillingType: this.price.dialogInsert.form.PriceBillingType,
          TargetFeeType: this.price.dialogInsert.form.TargetFeeType,
          StartValue: this.price.dialogInsert.form.StartValue,
          EndValue: this.price.dialogInsert.form.EndValue,
          StartPrice: this.price.dialogInsert.form.StartPrice,
          Percent: this.price.dialogInsert.form.Percent,
          UnitPrice: this.price.dialogInsert.form.UnitPrice,
          ValueUnit: this.price.dialogInsert.form.ValueUnit,
          CalcuModel: this.price.dialogInsert.form.CalcuModel
        }
        var url = ''
        if (data.Id === '' && data.OptimisticLock === '') {
          url = this.constant.openPaths.insertChannelPrice
        } else {
          url = this.constant.openPaths.updateChannelPrice
        }
        var self = this
        this.$refs[this.price.dialogInsert.form.formname].validate((valid) => {
          if (valid) {
            self.$ajax.post(url, data).then(res => {
              switch (res.data.code) {
                case 200:
                  self.$message({ message: res.data.msg, type: 'success' })
                  self.clearForm(self.price.dialogInsert.form)
                  self.searchChannelPrice()
                  self.price.dialogInsert.dialogvisible = false
                  break;
                case 402:
                  self.$router.push({ name: 'login' })
                  break
                default:
                  self.$message.error(res.data.msg)
                  break;
              }
            }).catch(error => {
              self.$message.error(error)
            })
          }
        })
      }
      else {
        this.$router.push({ name: 'login' })
      }
    },
    importChannelPrice (content) {
      let formData = new FormData()
      formData.append('UserId', this.userinfo.id)
      formData.append('EnterpriseId', this.userinfo.enterpriseId)
      formData.append('LoginToken', this.userinfo.loginToken)
      formData.append('ChannelId', this.price.search.ChannelId)
      formData.append('PriceVersionId', this.price.search.Version)
      formData.append('ItemType', this.price.search.ItemType)
      formData.append('ChannelLineId', this.price.search.ChannelLineId)
      formData.append('file', content.file)

      var self = this

      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.$ajax.post(this.constant.openPaths.importChannelPrice, formData, config).then(res => {
        if (res.data.code === 200) {
          var result = res.data.result
          switch (res.data.code) {
            case 200:
              self.$message({ message: res.data.msg, type: 'success' })
              self.searchChannelPrice()
              self.price.dialogImport.dialogvisible = false
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              self.$message.error(res.data.msg)
              break;
          }
          // content.onSuccess(res.data.msg)
          // self.$message({
          //   message: res.data.msg,
          //   type: 'success'
          // })
        }
        else {
          self.$message.error(res.data.msg)
          content.onError(res.data.msg)
        }
      })
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove (file, fileList) {
    },
    dialogImportPriceSave () {
      this.$refs.upload.submit()
    },
    dialogCopyPriceSave () { },
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/etms/tms/channel_price_setting.vue